import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6f96f336"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 1,
  id: "RankList"
};
var _hoisted_2 = {
  class: "style"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "style-title nav-title"
  }, "曲风榜", -1
  /* HOISTED */
  );
});

var _hoisted_4 = {
  class: "global"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "global-title nav-title"
  }, "全球榜", -1
  /* HOISTED */
  );
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Loading = _resolveComponent("Loading");

  var _component_RankOfficial = _resolveComponent("RankOfficial");

  var _component_PlayList = _resolveComponent("PlayList");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createCommentVNode(" 骨架屏 "), !_ctx.isShow ? (_openBlock(), _createBlock(_component_Loading, {
    key: 0
  })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 官方榜 "), _createVNode(_component_RankOfficial, {
    officialList: _ctx.officialList
  }, null, 8
  /* PROPS */
  , ["officialList"]), _createCommentVNode(" 曲风榜 "), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_PlayList, {
    playList: _ctx.styleList
  }, null, 8
  /* PROPS */
  , ["playList"])]), _createCommentVNode(" 全球榜 "), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_PlayList, {
    playList: _ctx.globalList
  }, null, 8
  /* PROPS */
  , ["playList"])])]))], 2112
  /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  );
}